/* WELCOME30 measurement only; never decides eligibility or changes the quiz UI. */
(function () {
  'use strict';
  if (window.WynchWelcomeAnalyticsV1) return;
  var policy = document.getElementById('wynch-welcome-policy-v1');
  if (!policy || JSON.parse(policy.textContent).loggedIn) return;
  var key = 'wynch_welcome_measurement_v2';
  var session = null, pending = null, observed = false;
  function allowed() {
    return !!(window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.analyticsProcessingAllowed());
  }
  function active() { return session && Date.now() - session.start < 1800000; }
  function publish(stage) {
    if (!allowed() || !active() || !Shopify.analytics || typeof Shopify.analytics.publish !== 'function') return;
    Shopify.analytics.publish('wynch_welcome_v1', { version: 1, token: session.token, stage: stage });
  }
  async function shown() {
    if (!allowed() || pending) return;
    if (active()) { publish('shown'); return; }
    pending = (async function () {
      try {
        var saved = JSON.parse(sessionStorage.getItem(key) || 'null');
        if (saved && typeof saved.token === 'string' && Number.isFinite(saved.start) && Date.now() - saved.start < 1800000) session = saved;
        if (!active()) {
          var response = await fetch((Shopify.routes.root || '/') + 'apps/wynch-email/welcome-session', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ version: 2, id: crypto.randomUUID(), device: (/Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) ? 'mobile' : 'desktop') }), signal: AbortSignal.timeout(3000)
          });
          if (!response.ok) return;
          var value = await response.json();
          if (typeof value.token !== 'string' || !Number.isFinite(value.start)) return;
          session = { token: value.token, start: value.start };
        }
        if (!allowed()) { session = null; return; }
        sessionStorage.setItem(key, JSON.stringify(session));
        publish('shown');
      } catch (_) { /* Measurement failures never interrupt shopping. */ }
    })();
    try { await pending; } finally { pending = null; }
  }
  var visible = new Set();
  var viewTimer;
  function visibleNow() {
    return Array.from(visible).some(function (el) {
      if (el.closest('[hidden]')) return false;
      var root = el.closest('.welcome-offer');
      if (el.matches('[data-popup]') && (!root || !root.classList.contains('is-open'))) return false;
      var style = getComputedStyle(el);
      return style.visibility !== 'hidden' && style.display !== 'none' && Number(style.opacity) > 0;
    });
  }
  function check() {
    clearTimeout(viewTimer);
    if (!visibleNow() || document.visibilityState !== 'visible' || !allowed()) return;
    viewTimer = setTimeout(function () { if (visibleNow() && document.visibilityState === 'visible') shown(); }, 500);
  }
  function observe() {
    if (observed || !allowed() || !window.IntersectionObserver) return;
    observed = true;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) visible.add(entry.target);
        else visible.delete(entry.target);
      }); check();
    }, { threshold: [0, 0.5] });
    document.querySelectorAll('.welcome-offer [data-widget], .welcome-offer [data-popup], [data-banner-card="guest"]').forEach(function (el) { observer.observe(el); });
    var changes = new MutationObserver(check);
    document.querySelectorAll('.welcome-offer, [data-banner-card="guest"]').forEach(function (el) { changes.observe(el, { attributes: true, subtree: true, attributeFilter: ['class', 'hidden', 'style'] }); });
  }
  window.WynchWelcomeAnalyticsV1 = {
    token: function () { return allowed() && active() ? session.token : ''; },
    claimed: function (cart, token) {
      var saved = cart && cart.attributes && cart.attributes.wynch_welcome_voucher === 'WELCOME30';
      if (saved && token && active() && token === session.token) {
        publish('added');
        if (window.WynchCommerceAnalyticsV2) window.WynchCommerceAnalyticsV2.activate('welcome', { token: token, start: session.start }, cart);
      }
    }
  };
  document.addEventListener('visitorConsentCollected', function () {
    if (!allowed()) { session = null; try { sessionStorage.removeItem(key); } catch (_) {} }
    else { observe(); check(); }
  });
  document.addEventListener('visibilitychange', check);
  // The privacy API can arrive after deferred theme assets.
  var attempts = 0;
  function start() { observe(); if (!observed && ++attempts < 40) setTimeout(start, 250); }
  start();
})();
